import { useLocation } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";
import { PAGES } from "@/seo/pages";

/**
 * Applies the metadata in src/seo/pages.js to whichever page is on screen, so every public route
 * has its own title, description and share card instead of the site-wide default. Pages that manage
 * their own tags (the funding editions, insight articles) run after this and win.
 */
export default function RouteSeo() {
  const { pathname } = useLocation();
  const clean = pathname.length > 1 ? pathname.replace(/\/+$/, "") : "/";
  const meta = PAGES[clean];

  useSeo({
    title: meta?.title,
    description: meta?.description,
    image: meta?.image ? `${window.location.origin}${meta.image}` : undefined,
  });

  return null;
}
